import React from "react";

import { StyledWrapper } from "../alertPanel/alertPanel.style";

const AlertPanel = ({ message }) => {
  return (
    <StyledWrapper>
      <div dangerouslySetInnerHTML={{ __html: message }}></div>
    </StyledWrapper>
  );
};

export default AlertPanel;
